import { useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

/**
 * useBreakpoint
 *
 * @returns
 */
const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState<string | undefined>();
  /**
   * useTheme
   */
  const theme = useTheme();

  /**
   * useMediaQuery
   *
   */
  const mq_xs = useMediaQuery(theme.breakpoints.only("xs"));
  const mq_sm = useMediaQuery(theme.breakpoints.only("sm"));
  const mq_md = useMediaQuery(theme.breakpoints.only("md"));
  const mq_lg = useMediaQuery(theme.breakpoints.only("lg"));
  const mq_xl = useMediaQuery(theme.breakpoints.only("xl"));

  useEffect(() => {
    const getBreakpointName = () => {
      if (mq_xs) {
        return "xs";
      }
      if (mq_sm) {
        return "sm";
      }
      if (mq_md) {
        return "md";
      }
      if (mq_lg) {
        return "lg";
      }
      if (mq_xl) {
        return "xl";
      }
    };

    setBreakpoint(getBreakpointName());
  }, [mq_xs, mq_sm, mq_md, mq_lg, mq_xl]);

  return {
    breakpoint,
  };
};

export default useBreakpoint;
